import React from 'react';
import PropTypes from 'prop-types';

import SrButton, { SR_BUTTON_THEME_ADOBE_RED_INVERTED } from 'client/components/SrButton/SrButton';

import './SrUtilityActivationStatusModalDelete.less';

const SrUtilityActivationStatusModalDelete = ({ onArchive }) => {
  return (
    <div styleName="SrUtilityActivationStatusModalDelete">
      <SrButton theme={SR_BUTTON_THEME_ADOBE_RED_INVERTED} onClick={onArchive}>
        Delete Utility Activation
      </SrButton>
      <div styleName="description">
        Only delete activations if they didn't really happen or will not happen because the renter
        is not planning on leasing the home anymore. The next renter who leases this home will not
        be blocked by this activation being here.
      </div>
    </div>
  );
};

SrUtilityActivationStatusModalDelete.propTypes = {
  onArchive: PropTypes.func.isRequired,
};

export default SrUtilityActivationStatusModalDelete;
